module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="result-header">\n	<div class="result-header__inner">\n		<div class="result-header__status">\n			<span class="loader-container"><div class="loader"><div class="m-loader"></div></div></span>\n			<span class="label"></span>\n		</div>\n		<div class="result-header__options">\n			<ul class="m-toggle-collection">\n				<li class="js-toggle-list m-toggle-collection--list"><span class="toggle__label">list</span></li>\n				<li class="js-toggle-map m-toggle-collection--map"><span class="toggle__label">map</span></li>\n			</ul>\n		</div>\n	</div>\n</div>\n<div id=\'map\'></div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/devices/map/templates/map.html
// module id = 442
// module chunks = 0